<script setup lang="ts">
import type { EmailParticipant } from '@apparatix/schemas/DashboardEmails';
import { SplitBar, Stack, Typography } from '@apparatix/library/core';
import NameAndEmail from '../orphaned-emails/NameAndEmail.vue';
import EmailDate from './EmailDate.vue';

type Props = {
  primaryParticipant: EmailParticipant,
  snippet: string,
  emailId: number,
  sentAt: number,
};

type Emits = {
  (e: 'expand-click', emailId: number): void,
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
</script>
<template>
  <Stack :gap="2" grow>
    <SplitBar>
      <template #left>
        <NameAndEmail :name="props.primaryParticipant.name" :email="props.primaryParticipant.email" multiline-on-mobile />
      </template>
      <template #right>
        <EmailDate :date="props.sentAt" />
      </template>
    </SplitBar>
    <div class="flex">
      <div class="grow pr-2 lg:pr-4">
        <Typography variant="body" class="leading-none">
          {{ props.snippet }}
        </Typography>
      </div>
      <div class="flex-none">
        <span
          class="pi pi-plus cursor-pointer"
          style="color: var(--p-button-text-primary-color)"
          aria-label="Show message details"
          @click="emit('expand-click', props.emailId)"
        />
      </div>
    </div>
  </Stack>
</template>
